/* Cashdro api response */
export interface CashdroErrorMessageResponse {
  errorMessage: string;
}

export interface CashdroResponse<
  T extends CashdroErrorMessageResponse = CashdroErrorMessageResponse
> {
  code: number;
  response: T;
}

/* END  cashdro api response */

/* BC formated Response */
export interface Error {
  msg: string;
  reason: string;
}

export interface Result<T> {
  ok: boolean;
  content: T;
  error: Error;
}

export interface BCCashdropResponseInterface<T> {
  ok(): boolean;
  ko(): boolean;
  getResult(): Result<T>;
}

export class BCCashdroResponse<T> implements BCCashdropResponseInterface<T> {
  constructor(public isOkey: boolean, public content: T, public error: Error) {
    this.isOkey = isOkey;
    this.content = content;
    this.error = error;
  }
  ok(): boolean {
    return this.isOkey && this.content ? true : false;
  }
  ko(): boolean {
    return !this.isOkey && this.error ? true : false;
  }
  getResult(): Result<T> {
    return {
      ok: this.ok(),
      content: this.content,
      error: this.error,
    };
  }
}
